<template>
    <div class="seenotice">
        <el-row>
            <el-col :span="3">
                <h4>消息中心</h4>
                <ul class="left_list">
                    <li
                        v-for="(item,index) in left_list"
                        :key="index"
                        @click="set_List(index)"
                        :class="{active : set_type === index}"
                    >
                        {{item}}
                        <span>2</span>
                    </li>
                </ul>
            </el-col>
            <el-col :span="20">
                <div class="seenotice_right">
                    <span
                        v-for="(item,index) in list"
                        :key="index"
                        @click="see_List(index)"
                        :class="{active : see_type === index}"
                    >{{item}}</span>
                    <div style="float: right;" v-show="set_type === 0 || set_type === 1">
                        <el-button>标记已读</el-button>
                        <el-button>全部已读</el-button>
                    </div>
                </div>
                <div>
                    <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="name" label="标题内容" width="1000"></el-table-column>
                        <el-table-column label="日期">
                            <template slot-scope="scope">{{ scope.row.date }}</template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作">
                            <template slot-scope="scope">
                                <el-button @click="handleClick(scope.row)" type="text">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        style="float: right;padding: 30px 0px;"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage4"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="400"
                    ></el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "notice",
    data() {
        return {
            list: ["全部", "提醒", "内部备注", "库房备注", "财务备注"],
            tableData: [{ name: "内部备注", date: "2016-05-03" }],
            currentPage4: 2,
            see_type: 0,
            set_type: 0,
            left_list: ["全部信息", "未读信息", "已读信息", "消息设置"]
        };
    },
    mounted() {},
    created() {},
    methods: {
        handleSelectionChange(val) {
            console.log(val);
        },
        handleClick() {
            this.$router.push({
                path: "/dashboard/notice_details",
                query: {
                    id: "1"
                }
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        see_List(index) {
            this.see_type = index;
        },
        set_List(index) {
            this.set_type = index;
        }
    }
};
</script>

<style lang="scss" scoped>
.seenotice {
    overflow: hidden;
    h4 {
        line-height: 50px;
        background: #ebedf0;
        font-size: 18px;
        padding: 0 20px;
    }
    .left_list {
        background: #fafbfc;
        li {
            line-height: 50px;
            padding: 0 20px;
            span {
                display: block;
                float: right;
                padding: 0 15px;
            }
        }
        .active {
            color: #1884fc;
            background: #fff;
        }
    }
    .seenotice_right {
        border-bottom: 1px solid #eee;
        padding: 0 0 0 10px;
        overflow: hidden;
        span {
            display: block;
            float: left;
            padding: 0 15px;
            line-height: 49px;
        }
        .active {
            color: #1884fc;
            border-bottom: 1px solid #1884fc;
        }
    }
}
</style>